/*
 * Fortera Bulk Order + Customily Bridge v2
 *
 * Intercepts BOTH fetch and XMLHttpRequest to /cart/add.
 * Reads Customily properties directly from form DOM.
 * Prevents duplicate cart additions.
 */

(function () {
  'use strict';

const COLLAR_SELECTOR = 'input[type="checkbox"][name*="Collar Logo"]';
const SLEEVES_SELECTOR = 'input[type="checkbox"][name*="Sleeves Logo"]';
  const COLLAR_SURCHARGE = 400;
  const SLEEVES_SURCHARGE = 400;
  const EMBROIDERY_FEE_VARIANT_ID = 47296009535666;

  class CustomilyBridge {
    constructor() {
      this.surcharge = 0;
      this._patched = false;
      this._bulkAddInProgress = false;
      this.init();
    }

    init() {
      // Support both fortera-bulk-order (polos) and fortera-scrubs-order (scrubs)
      const bulkEl = document.querySelector('fortera-bulk-order, fortera-scrubs-order');
      if (!bulkEl) return;
      this.patchNetworking();
      this.waitForCheckboxes();
      this.hideDynamicCheckout();
      this.reorderCustomilyUI();
    }

    reorderCustomilyUI() {
      const bulkOrder = document.querySelector('fortera-bulk-order, fortera-scrubs-order');
      if (!bulkOrder) return;
      const parent = bulkOrder.parentElement;
      if (!parent) return;

      const move = () => {
        const clUI = document.getElementById('cl_optionsapp');
        if (!clUI) return false;

        const customilyWrapper = document.createElement('div');
        customilyWrapper.className = 'fortera-customily-wrapper';
        clUI.parentElement.insertBefore(customilyWrapper, clUI);
        customilyWrapper.appendChild(clUI);
        parent.insertBefore(customilyWrapper, bulkOrder);

        const sizeGuideBtn = parent.querySelector('.ft-sg-opener');
        if (sizeGuideBtn) {
          parent.insertBefore(sizeGuideBtn, bulkOrder);
        }

        const productFormContainer = parent.querySelector('product-form')?.closest('.product__info-container > div');
        if (productFormContainer) {
          bulkOrder.nextSibling
            ? parent.insertBefore(productFormContainer, bulkOrder.nextSibling)
            : parent.appendChild(productFormContainer);
        }

        return true;
      };

      if (!move()) {
        let attempts = 0;
        const check = setInterval(() => {
          attempts++;
          if (move() || attempts > 50) clearInterval(check);
        }, 200);
      }
    }

    /* ---- Detect Customily checkboxes ---- */
    waitForCheckboxes() {
      let attempts = 0;
      const check = () => {
        attempts++;
        const collar = document.querySelector(COLLAR_SELECTOR);
        const sleeves = document.querySelector(SLEEVES_SELECTOR);
        if (collar || sleeves) {
          this.bindCheckboxes(collar, sleeves);
          return;
        }
        if (attempts < 100) setTimeout(check, 100);
      };
      check();
    }

    bindCheckboxes(collarCb, sleevesCb) {
      const onChange = () => {
        const collarOn = collarCb ? collarCb.checked : false;
        const sleevesOn = sleevesCb ? sleevesCb.checked : false;
        const s = (collarOn ? COLLAR_SURCHARGE : 0) + (sleevesOn ? SLEEVES_SURCHARGE : 0);
        if (s !== this.surcharge) {
          this.surcharge = s;
          this.applySurcharge();
        }
      };
      if (collarCb) collarCb.addEventListener('change', onChange);
      if (sleevesCb) sleevesCb.addEventListener('change', onChange);

      const container = (collarCb || sleevesCb).closest('.shopify-app-block, [id*="customily"]');
      if (container) {
        container.addEventListener('click', () => setTimeout(onChange, 50), true);
      }
    }

    applySurcharge() {
      const bulk = document.querySelector('fortera-bulk-order, fortera-scrubs-order');
      if (bulk && typeof bulk.setSurcharge === 'function') {
        bulk.setSurcharge(this.surcharge);
      }
      this.updateSectionPrice();
    }

    updateSectionPrice() {
      const priceEl =
        document.querySelector('[id^="price-"] .price-item--regular') ||
        document.querySelector('[id^="price-"] .price-item--sale');
      if (!priceEl) return;
      const row = document.querySelector('.fortera-bulk-order__row[data-available="true"]');
      if (!row) return;
      const base = parseInt(row.dataset.basePrice) || 0;
      priceEl.textContent = ((base + this.surcharge) / 100).toLocaleString('en-US', {
        style: 'currency', currency: 'USD',
      });
    }

    hideDynamicCheckout() {
      const s = document.createElement('style');
      s.textContent = '.product-form .shopify-payment-button{display:none!important}';
      document.head.appendChild(s);
    }

    /* ---- Read properties from form DOM ----
     * Customily renders its own UI (color radios, logo uploads, text inputs)
     * OUTSIDE the Shopify add-to-cart form, inside a #cl-set-*-cl-opt block.
     * So we scan the whole document instead of just the ATC form. Hidden
     * inputs created by Customily (e.g. logo CDN URLs, preview thumbnails)
     * are picked up here and forwarded to /cart/add as line item properties.
     */
    getPropertiesFromDOM() {
      const props = {};

      document.querySelectorAll('input[name^="properties["]').forEach((input) => {
        const m = input.name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        const key = m[1];
        if (input.type === 'checkbox') {
          if (input.checked) props[key] = 'on';
        } else if (input.type === 'radio') {
          if (input.checked) props[key] = input.value || 'on';
        } else if (input.value) {
          props[key] = input.value;
        }
      });

      document.querySelectorAll('textarea[name^="properties["]').forEach((ta) => {
        const m = ta.name.match(/^properties\[(.+)\]$/);
        if (m && ta.value) props[m[1]] = ta.value;
      });

      document.querySelectorAll('select[name^="properties["]').forEach((sel) => {
        const m = sel.name.match(/^properties\[(.+)\]$/);
        if (m && sel.value) props[m[1]] = sel.value;
      });

      return props;
    }

    /* ---- Get bulk items (supports both bulk-order and scrubs-order) ---- */
    getBulkItems() {
      const bulk = document.querySelector('fortera-bulk-order, fortera-scrubs-order');
      if (!bulk || typeof bulk.getItems !== 'function') return [];
      return bulk.getItems();
    }

    /* ---- Build bulk payload ---- */
    buildBulkPayload() {
      const items = this.getBulkItems();
      if (items.length === 0) return null;

      const properties = this.getPropertiesFromDOM();
      const totalQty = items.reduce((sum, i) => sum + i.quantity, 0);

      const payloadItems = items.map((item) => {
        const entry = { id: item.id, quantity: item.quantity };
        if (Object.keys(properties).length > 0) {
          entry.properties = { ...properties };
        }
        return entry;
      });

      const collarCb = document.querySelector(COLLAR_SELECTOR);
      const sleevesCb = document.querySelector(SLEEVES_SELECTOR);

      if (collarCb && collarCb.checked && totalQty > 0) {
        payloadItems.push({
          id: EMBROIDERY_FEE_VARIANT_ID,
          quantity: totalQty,
          properties: { 'Logo Position': 'Collar' },
        });
      }
      if (sleevesCb && sleevesCb.checked && totalQty > 0) {
        payloadItems.push({
          id: EMBROIDERY_FEE_VARIANT_ID,
          quantity: totalQty,
          properties: { 'Logo Position': 'Sleeves' },
        });
      }

      const payload = { items: payloadItems };

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
      }

      return payload;
    }

    /* ---- Post-add: update cart UI and reset ---- */
    async onBulkAddSuccess(data) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (cart && data && !data.status) {
        try { cart.renderContents(data); } catch (_) {}
      }
      await this.refreshCartBubble();


      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fortera-bulk-bridge', cartData: data });
      }

      const bulk = document.querySelector('fortera-bulk-order, fortera-scrubs-order');
      if (bulk) {
        bulk.querySelectorAll('.fortera-bulk-order__input').forEach((i) => { i.value = 0; });
        if (typeof bulk.updateTotals === 'function') bulk.updateTotals();
      }

      const submitBtn = document.querySelector('.product-form__submit');
      if (submitBtn) {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
        const spinner = submitBtn.closest('product-form')?.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    async refreshCartBubble() {
      try {
        const fn = window._originalFetch || window.fetch;
        const sectionRes = await fn('/?sections=cart-icon-bubble');
        const sections = await sectionRes.json();
        const html = sections['cart-icon-bubble'];
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon && html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wrapper = doc.querySelector('.shopify-section');
          if (wrapper) cartIcon.innerHTML = wrapper.innerHTML;
        }
      } catch (_) {}
    }

    /* ---- Patch fetch AND XMLHttpRequest ---- */
    patchNetworking() {
      if (this._patched) return;
      this._patched = true;

      const bridge = this;

      // Save originals
      const originalFetch = window.fetch.bind(window);
      window._originalFetch = originalFetch;

      const XHROpen = XMLHttpRequest.prototype.open;
      const XHRSend = XMLHttpRequest.prototype.send;

      // --- Patch fetch ---
      window.fetch = function (url, options) {
        const u = typeof url === 'string' ? url : (url && url.url) || '';

        if (u.includes('/cart/add') && options && options.method &&
            options.method.toUpperCase() === 'POST') {
          return bridge.handleCartAdd(originalFetch);
        }
        return originalFetch.apply(window, arguments);
      };

      // --- Patch XMLHttpRequest ---
      XMLHttpRequest.prototype.open = function (method, url) {
        this._forteraMethod = method;
        this._forteraUrl = url;
        return XHROpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function (body) {
        const url = this._forteraUrl || '';
        const method = (this._forteraMethod || '').toUpperCase();

        if (url.includes('/cart/add') && method === 'POST') {
          const items = bridge.getBulkItems();
          if (items.length > 0) {
            if (bridge._bulkAddInProgress) {
              this.dispatchEvent(new Event('load'));
              Object.defineProperty(this, 'status', { value: 200 });
              Object.defineProperty(this, 'responseText', { value: '{"items":[]}' });
              return;
            }

            bridge._bulkAddInProgress = true;
            setTimeout(() => { bridge._bulkAddInProgress = false; }, 3000);

            bridge.handleCartAdd(originalFetch).then(() => {
              this.dispatchEvent(new Event('load'));
            });
            return;
          }
        }

        return XHRSend.apply(this, arguments);
      };
    }

    /* ---- Central handler for /cart/add interception ---- */
    async handleCartAdd(originalFetch) {
      if (this._bulkAddInProgress) {
        return new Response('{"items":[]}', {
          status: 200,
          headers: { 'Content-Type': 'application/json' },
        });
      }

      const payload = this.buildBulkPayload();
      if (!payload) {
        return new Response('{"items":[]}', {
          status: 200,
          headers: { 'Content-Type': 'application/json' },
        });
      }

      this._bulkAddInProgress = true;
      setTimeout(() => { this._bulkAddInProgress = false; }, 3000);

      try {
        const response = await originalFetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        await this.onBulkAddSuccess(data);

        return new Response(JSON.stringify(data), {
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
        });
      } catch (err) {
        console.error('[Fortera Bridge] Bulk add failed:', err);
        this._bulkAddInProgress = false;
        throw err;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CustomilyBridge());
  } else {
    new CustomilyBridge();
  }
})();
